import React from "react";
import clsx from "clsx";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

// Material Icons
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

// Config
import colors from "../../config/colors";
import { externalRoutes } from "../../config/urls";
import { analyticsClassNames } from "../../config/googleAnalitycs";
import { getTextSingle, language } from "../../languages/Languages";
import { getText } from "../../utils/textUtils";

// Icons
import publicPlatformIcon from "../../assets/icons/public_platform.svg";
import policePlatformIcon from "../../assets/icons/police_platform.svg";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex"
  },
  loginStyle: {
    minWidth: "140px",
    fontSize: 17,
    textTransform: "none",
    boxShadow: "none",
    fontFamily: "Maven Pro",
    fontWeight: 500,
    backgroundColor: colors.lightBlue,
    "&:hover": {
      backgroundColor: colors.lightBlue
    },
    color: colors.white
  },
  loginActive: {
    backgroundColor: "#1B8595"
  },
  paper: {
    backgroundColor: "#fff",
    boxShadow: "0px 1px 23px #0000001F"
  },
  list: {
    padding: 0
  },
  menuItem: {
    padding: "20px",
    gap: "20px",
    display: "flex",
    flexDirection: "row",
    width: "255px",
    fontFamily: ["Maven Pro", "Open Sans", "sans-serif"].join(","),
    fontWeight: "500",
    fontSize: "16px"
  },
  menuItemIcon: {
    height: "20px"
  }
}));

const LoginButton = props => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const classes = useStyles();
  const { className, children, ...rest } = props;
  // Text
  const { login, policePlatform, publicPlatform } = language.common;

  return (
    <Box className={classes.root}>
      <Button
        {...rest}
        className={clsx(
          className,
          classes.loginStyle,
          analyticsClassNames.downloadLink,
          {
            [classes.loginActive]: Boolean(anchorEl)
          }
        )}
        variant="contained"
        aria-controls="login-menu"
        aria-haspopup="true"
        onClick={e => handleClick(e)}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {getTextSingle(login)}
      </Button>
      <Menu
        id="login-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        classes={{
          paper: classes.paper,
          list: classes.list
        }}
        elevation={0}
      >
        <MenuItem
          component="a"
          href={externalRoutes.webapp}
          rel="noopener noreferrer"
          target="_blank"
          onClick={handleClose}
          className={classes.menuItem}
        >
          <img
            src={publicPlatformIcon}
            alt="Police Platform"
            className={classes.menuItemIcon}
          />
          {getText(publicPlatform)}
        </MenuItem>
        <Divider />
        <MenuItem
          component="a"
          href={externalRoutes.policeapp}
          rel="noopener noreferrer"
          target="_blank"
          onClick={handleClose}
          className={classes.menuItem}
        >
          <img
            src={policePlatformIcon}
            alt="Police Platform"
            className={classes.menuItemIcon}
          />

          {getText(policePlatform)}
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LoginButton;
